module.exports = __webpack_public_path__ + "img/product14p.117024c3.png";